import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles(({ breakpoints, palette, colors } : Theme) => createStyles({
  container: {
    marginBottom: 30,
  },
  title: {
    fontSize: 12,
    color: '#515B6A',
    marginBottom: 8,
  },
  creditCounter: {
    fontSize: 32,
    color: palette.text.primary,
  },
  button: {
    marginTop: 20,
  },
  noteWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  note: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  icon: {
    color: colors.icon,
    fontSize: '1rem',
    verticalAlign: 'middle',
  },
  comment: {
    fontSize: '12px',
    padding: '0 10px 0 10px',
  },
  commentButtonWrapper: {
    width: '48px',
    textAlign: 'center',
  },
  nowrap: {
    whiteSpace: 'nowrap',
  },
}));

export default useStyles;
